import React from "react";
import BaseGrid from "Components/Fragment/BaseGrid";
import EmptyState from "Components/Fragment/DataDisplay/EmptyState";
import { CheckCircle, SEARCH } from "Components/Icons";
import { useMyLearning } from "lib/components/MyLearning/context";
import AccordionCourses from "./AccordionCourses";
import AccordionProgram from "./AccordionProgram";

const MainContent = ({
  isManagerOrAdmin,
  onProgramClick,
  openDetails,
  closeDetails,
  languageContext,
}) => {
  const {
    isBt,
    filteredCourses,
    searching,
    filteredPrograms,
    filter,
    clearFilter,
    totalPercentCompleted,
  } = useMyLearning();

  const noActiveResults =
    !filteredCourses?.active?.length &&
    !filteredPrograms?.active?.length &&
    !searching;

  const noFiltersApplied =
    !filter?.searchText &&
    (Array.isArray(filter?.selectedTags)
      ? filter.selectedTags.every((t) => t === 0)
      : true) &&
    (!filter?.categoryId || filter.categoryId === 0) &&
    filter?.status === "all" &&
    !filter?.displayAdminCourses;

  if (noActiveResults) {
    if (totalPercentCompleted === 100 && noFiltersApplied) {
      return (
        <EmptyState
          icon={<CheckCircle />}
          title={languageContext("myLearningAllCompleted")}
        />
      );
    }
    return (
      <EmptyState
        icon={<SEARCH />}
        title={languageContext("noResult")}
        description={languageContext("noResultsDescription")}
        actionLabel={languageContext("clearFilters")}
        onAction={clearFilter}
      />
    );
  }

  return (
    <BaseGrid
      childWidth="auto"
      justifyContent={"space-between"}
      direction="column"
    >
      <AccordionProgram
        isManagerOrAdmin={isManagerOrAdmin}
        onProgramClick={onProgramClick}
        languageContext={languageContext}
      />
      {!isBt && filteredCourses?.active?.length > 0 && (
        <AccordionCourses
          isManagerOrAdmin={isManagerOrAdmin}
          openDetails={openDetails}
          closeDetails={closeDetails}
          languageContext={languageContext}
        />
      )}
    </BaseGrid>
  );
};

export default MainContent;
